var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spec-many-type"},[_c('div',{staticClass:"spec-wrap"},[(!_vm.form.isSpecLocked)?_c('div',[_c('el-button',{staticClass:"el-icon-circle-plus",attrs:{"size":"small"},on:{"click":_vm.onToggleAddGroupForm}},[_vm._v(_vm._s(_vm.$t('添加规格'))+" ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6887f428","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/buildstore/goods/store/product/part/spec/many/Type.vue
// module id = null
// module chunks = 